   <template>
    <b-container>
        <b-row>
            <b-col cols="12">
                <b-form-group
                    id="fieldset-driver"
                    label="Officer"
                    label-for="input-officer"
                >
                    <b-form-select
                        id="input-officer"
                        v-model="model.driver_id"
                        :options="driverOptions"
                    ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="6">
                <b-form-group
                    id="fieldset-created_start"
                    label="Start Date"
                    label-for="input-created_start"
                >
                    <b-form-input
                        type="date"
                        id="input-created_start"
                        v-model="model.created_start"
                    ></b-form-input>
                </b-form-group>
            </b-col>

            <b-col cols="6">
                <b-form-group
                    id="fieldset-created_end"
                    label="End Date"
                    label-for="input-created_end"
                >
                    <b-form-input
                        type="date"
                        id="input-created_end"
                        v-model="model.created_end"
                    ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="4">
                <b-form-group
                    id="fieldset-type"
                    label="Type"
                    label-for="input-type"
                >
                    <b-form-select
                        id="input-type"
                        value-field="id"
                        text-field="name"
                        v-model="model.order_type_id"
                        :options="orderTypes"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group
                    id="fieldset-is_updated"
                    label="Updates"
                    label-for="input-is_updated"
                >
                    <b-form-select
                        id="input-is_updated"
                        v-model="model.is_updated"
                        :options="is_updatedOptions"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group
                    id="fieldset-completed"
                    label="Completed"
                    label-for="input-completed"
                >
                    <b-form-select
                        id="input-completed"
                        v-model="model.completed"
                        :options="completedOptions"
                    ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import moment from 'moment'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'reports-queryBuilder',
    mixins: [permissionsMixins],
    data: () => ({
        model: {
            driver_id: 0,
            completed: 'any',
            order_type_id: 0,
            created_start: moment().startOf('month').format('YYYY-MM-DD'),
            created_end: moment().endOf('month').format('YYYY-MM-DD'),
            updated_at: moment().startOf('month').format('YYYY-MM-DD'),
            is_updated: 'any',
        },
    }),
    props: ['value', 'orderTypes', 'drivers'],
    computed: {
        driverOptions() {
            const drivers = this.drivers.map(x => ({
                value: x.id,
                text: `${x.first_name} ${x.last_name}`,
            }))

            drivers.unshift(
                { value: 0, text: 'Any' },
                { value: -1, text: 'Assigned' },
                { value: -2, text: 'Unassigned' }
            )
            return drivers
        },
        is_updatedOptions() {
            return [
                { value: 'any', text: 'Any' },
                { value: 'changed', text: 'Changed' },
                { value: 'notChanged', text: 'Not Changed' },
            ]
        },

        completedOptions() {
            return [
                { value: 'any', text: 'Any' },
                { value: 'yes', text: 'Yes' },
                { value: 'no', text: 'No' },
            ]
        },
    },
    watch: {
        'model.driver_id': function () {
            this.updateModel()
        },
        'model.created_start': function () {
            this.updateModel()
        },
        'model.created_end': function () {
            this.updateModel()
        },
        'model.order_type_id': function () {
            this.updateModel()
        },
        'model.is_updated': function () {
            this.updateModel()
        },
        'model.completed': function () {
            this.updateModel()
        },

        value: {
            handler: function (val) {
                this.setModel(val)
            },
            deep: true,
        },
    },
    mounted() {
        this.setModel(this.value)
        console.log('DRIVERS', this.drivers)
    },
    methods: {
        updateModel() {
            const $this = this
            this.$nextTick(() => {
                $this.$emit('input', { ...$this.model })
            })
        },
        setModel({
            driver_id,
            created_start,
            created_end,
            order_type_id,
            is_updated,
            completed,
        }) {
            this.model = {
                driver_id,
                created_start,
                created_end,
                order_type_id,
                is_updated,
                completed,
            }
        },
    },
}
</script>